import { Link } from "react-router-dom";
import ButtonOne from "../../../components/buttons/buttonOne";

export default function IntroRoboticMakers() {
    return (
        <div className="flex flex-col w-full h-full items-center justify-center gap-y-[2rem] py-[2rem]">
            <div className="flex flex-col xl:flex-row justify-center items-center w-[80%] xl:w-[70%] h-full">
                <img
                    src="/pictures/introRoboticMaker.webp"
                    alt="PCB and components for an engineering kit used in education robotics"
                    className="xl:w-[50%] max-w-l h-auto"
                />
                <div className="flex flex-col gap-y-[1rem] w-[90%] xl:w-[50%] xl:ml-[3rem] text-xl font-semibold">
                    <h2 className="text-4xl font-bold">A Robotics Kit For <span className="text-[#4153C5]">Makers</span></h2>
                    <p>
                        H.I.R.O. is built with Raspberry Pi Pico with libraries written for Arduino IDE. H.I.R.O. is a robotics kit for designed for the D.I.Y. community.
                    </p>
                    <p>
                        We believe in empowering the maker community through open source robotics kits, with all-levels learning, hacking, and the right to repair at the center of our design philosophy. 
                    </p>
                    <p>
                        This is a kit by makers for makers.
                    </p>

                    {/* TODO: Redirect Kickstart page */}
                    <Link to="https://shop.takamorirobot.com" target="_blank" aria-label="Learn more about our beginner robotics course and engineering kit">
                        <ButtonOne 
                            position=""
                            bgColor="#F32047"
                        >
                            {/* Learn More */}
                            Our Store
                        </ButtonOne>
                    </Link>
                </div>
            </div>
        </div>
    )
}